export default "__VITE_ASSET__Cl$yTHA7__"